import { render, staticRenderFns } from "./RateDialog.vue?vue&type=template&id=d405e846&lang=pug&"
import script from "./RateDialog.vue?vue&type=script&lang=ts&"
export * from "./RateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports